import {TranslationInterpreter} from '../../TranslationProvider/TranslationContext';
import {
  AlignCenterToolbarIcon,
  AlignJustifyToolbarIcon,
  AlignLeftToolbarIcon,
  AlignRightToolbarIcon,
  BoldToolbarIcon,
  ItalicToolbarIcon,
  OrderedListToolbarIcon,
  StrikethroughToolbarIcon,
  UnderlineToolbarIcon,
  UnorderedListToolbarIcon,
} from '../components/ToolbarIcons';
import {RichTextToolbarAction, ToolbarButtonDefinition} from './types';

export function getToolbarButtonRegistry(
  t: TranslationInterpreter
): Record<Exclude<RichTextToolbarAction, 'emoji' | 'formatselect'>, ToolbarButtonDefinition> {
  return {
    bold: {
      ariaLabel: t('richText.toolbar.bold'),
      command: 'bold',
      icon: <BoldToolbarIcon />,
    },
    italic: {
      ariaLabel: t('richText.toolbar.italic'),
      command: 'italic',
      icon: <ItalicToolbarIcon />,
    },
    underline: {
      ariaLabel: t('richText.toolbar.underline'),
      command: 'underline',
      icon: <UnderlineToolbarIcon />,
    },
    strikethrough: {
      ariaLabel: t('richText.toolbar.strikethrough'),
      command: 'strikeThrough',
      icon: <StrikethroughToolbarIcon />,
    },
    unorderedlist: {
      ariaLabel: t('richText.toolbar.bulletedList'),
      command: 'insertUnorderedList',
      icon: <UnorderedListToolbarIcon />,
    },
    orderedlist: {
      ariaLabel: t('richText.toolbar.numberedList'),
      command: 'insertOrderedList',
      icon: <OrderedListToolbarIcon />,
    },
    alignleft: {
      ariaLabel: t('richText.toolbar.alignLeft'),
      command: 'justifyLeft',
      icon: <AlignLeftToolbarIcon />,
    },
    aligncenter: {
      ariaLabel: t('richText.toolbar.alignCenter'),
      command: 'justifyCenter',
      icon: <AlignCenterToolbarIcon />,
    },
    alignright: {
      ariaLabel: t('richText.toolbar.alignRight'),
      command: 'justifyRight',
      icon: <AlignRightToolbarIcon />,
    },
    alignjustify: {
      ariaLabel: t('richText.toolbar.justify'),
      command: 'justifyFull',
      icon: <AlignJustifyToolbarIcon />,
    },
  };
}
